import { NavLink, useLocation } from 'react-router-dom';
import { Home, BookOpen, BarChart3, User, Sparkles } from 'lucide-react';

const items = [
  { to: '/', label: 'Сегодня', Icon: Home },
  { to: '/diary', label: 'Дневник', Icon: BookOpen },
  { to: '/chat', label: 'Дофи', Icon: Sparkles, accent: true },
  { to: '/stats', label: 'Статистика', Icon: BarChart3 },
  { to: '/profile', label: 'Профиль', Icon: User },
];

export function BottomNav() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/workout/')) return null;
  // Тестовый онбординг из админки: у настоящего онбординга нижнего меню нет,
  // а здесь оно перекрывало кнопку «Начать».
  if (pathname === '/onboarding-test') return null;
  return (
    <nav className="bottom-nav fixed bottom-0 inset-x-0 z-30 bg-bg/90 backdrop-blur-xl border-t border-line">
      <div className="max-w-md mx-auto grid grid-cols-5 px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        {items.map(({ to, label, Icon, accent }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2 rounded-lg transition-colors ${
                isActive
                  ? 'text-emerald-glow'
                  : accent
                  ? 'text-emerald-glow/60'
                  : 'text-ink-dim'
              }`
            }
          >
            <Icon size={20} />
            <span className="text-[10px] font-medium">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
